<div class="entity-actions">
  <button
    class="action-button action-button-delete"
    [disabled]="isControlsDisabled"
    (click)="btnClicked.emit('REMOVE')"
    title="Remove Counterparty"
  >
    <rkt-icon name="trash"></rkt-icon>
  </button>

  @if (counterparty?.state !== 'SUSPENDED') {
    <button
      class="action-button action-button-suspend"
      [disabled]="isControlsDisabled"
      (click)="btnClicked.emit('SUSPEND')"
      title="Suspend Counterparty"
    >
      <rkt-icon name="suspend"></rkt-icon>
    </button>
  }

  @if (counterparty?.state === 'SUSPENDED') {
    <button
      class="action-button action-button-unsuspend"
      [disabled]="isControlsDisabled"
      (click)="btnClicked.emit('UNSUSPEND')"
      title="Unsuspend Counterparty"
    >
      <rkt-icon name="resume"></rkt-icon>
    </button>
  }
</div>
